import React, { useEffect } from 'react'
import { Flex, Box, Text } from 'rebass'
import { GridColDef } from '@mui/x-data-grid-pro'
import { theme } from 'theme'
import { useDispatch, useSelector } from 'react-redux'
import { useNewTranslation } from 'hooks/index'
import { selectRequestsAreLoading } from 'state'
import { STATE_KEYS } from 'state/requests'
import { selectBannerGroups, getBannerGroups, clearBannerGroups, clearBanners } from 'state/banners' //, getBanners
import PartiTable from 'components/Shared/MuiTable/PartiTable'
import { getColumns, getRows, RowsProps } from './BannerGroupsTableDef'
import { TableViewType } from 'components/Shared/MuiTable'
import Divider from 'components/Divider'

const BannerGroups: React.FC = () => {
    const [newT] = useNewTranslation()
    const dispatch = useDispatch()
    const isLoading = useSelector(selectRequestsAreLoading([STATE_KEYS.GetBannerGroups]))
    const bannerGroups = useSelector(selectBannerGroups)

    useEffect(() => {
        dispatch(clearBannerGroups())
        dispatch(clearBanners())
        dispatch(getBannerGroups())
    }, [])

    const bannerGroupsColumns: GridColDef[] = getColumns()
    const bannerGroupsRows: RowsProps[] = getRows(bannerGroups)
    return (
        <Flex>
            <Box flex={1} m={'24px'}>
                <Box>
                    <Text fontSize={'18px'} fontWeight={'bold'} color={theme.colors.mineShaft} textAlign={'left'}>
                        {newT('banner.bannerGroupsPageTitle', 'Banner Groups')}
                    </Text>
                    <Divider mt={'24px'} mb={'32px'} sx={{ borderWidth: '4px' }} />
                </Box>

                <PartiTable
                    rowHeight={120}
                    columns={bannerGroupsColumns}
                    rows={bannerGroupsRows}
                    isLoading={isLoading}
                    hideToolbar={true}
                    enableExport={false}
                    showFilter={false}
                    showSearchBar={false}
                    viewType={TableViewType.BANNER_GROUP}
                    disableColumnMenu={true}
                />
            </Box>
        </Flex>
    )
}

export default BannerGroups
